var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1224 27.1227H23.0727V20.7805C23.0727 19.2681 23.0457 17.3212 20.9664 17.3212C18.8571 17.3212 18.5343 18.969 18.5343 20.6704V27.1223H14.4844V14.0801H18.3723V15.8624H18.4267C19.2195 14.507 20.6935 13.6974 22.2627 13.7557C26.3674 13.7557 27.1242 16.4556 27.1242 19.9679L27.1225 27.1227H27.1224ZM9.91484 12.2973C8.61691 12.2975 7.56457 11.2455 7.56437 9.94755C7.56417 8.64962 8.6162 7.59728 9.91413 7.59709C11.212 7.59689 12.2644 8.64887 12.2646 9.94677C12.2648 11.2447 11.2129 12.2971 9.91492 12.2973H9.91485H9.91484ZM11.9398 27.1227H7.8857V14.0801H11.9398V27.1227H11.9398ZM29.1415 3.83614H5.85064C4.74989 3.82371 3.84719 4.70543 3.83374 5.80617V29.1936C3.84672 30.2949 4.74935 31.1775 5.85064 31.1658H29.1415C30.2449 31.1796 31.1511 30.2971 31.1664 29.1936V5.80448C31.1506 4.70155 30.2444 3.81986 29.1415 3.83441",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.85c6c64030c35052fef6358256c3249f.svg";
export { ForwardRef as ReactComponent };